import { Component, ViewChild, ElementRef, AfterViewInit } from "@angular/core";
import ReactDOM from "react-dom";
import React from "react";
import {
    BusinessComponentsProvider,
    AuthClientConfig,
} from "@dfds-platform/business-components";
import OktaLogin from "./okta.login";
import { OktaService } from "./okta.service";

@Component({
    selector: "sbw-okta",
    template: "<div #react></div>",
})
export class OktaProviderComponent implements AfterViewInit {
    [x: string]: any;
    constructor(public oktaService: OktaService) {}

    @ViewChild("react", { static: true }) react: ElementRef;

    ngAfterViewInit() {
        this.render();
    }

    render() {
        const OktaProvider = ({}) => {
            const oktaConfig: AuthClientConfig = {
                applicationEnvironment: window["okta_environment"],
                clientId: window["okta_clientId"],
                issuer: window["okta_issuer"],
                businessArea: "Passenger",
                redirectUri: window.location.origin,
            };

            return (
                <BusinessComponentsProvider oktaConfig={oktaConfig}>
                    <OktaLogin
                        onSubmitted={this.oktaService.onOktaSubmitted}
                        onLoggingOut={this.oktaService.onOktaLogout}
                        onAuthenticate={this.oktaService.onOktaAuthenticate}
                    />
                </BusinessComponentsProvider>
            );
        };

        ReactDOM.render(<OktaProvider />, this.react.nativeElement);
    }
}
